export default {
    app: "__mesoestetic_app_selected__",
    appLanguage: "__mesoestetic_app_language__",
    appUser: "__mesoestetic_app_userdata__",
    notification: "notification"
}